import { __extends } from "tslib";
import { MDCRipple } from '@material/ripple';
var TylRipple = /** @class */ (function (_super) {
    __extends(TylRipple, _super);
    function TylRipple() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TylRipple;
}(MDCRipple));
export { TylRipple };
